/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidSourceResponsesDto } from '../../models/prebid-source-responses-dto';

export interface GetMongoDataPrebidSourceResponses$Params {
  '$page': number;
  '$maxpagesize': number;
  source?: string;
  succeeded?: boolean;
  fromDate?: string;
  toDate?: string;
  'X-API-Version'?: string;
}

export function getMongoDataPrebidSourceResponses(http: HttpClient, rootUrl: string, params: GetMongoDataPrebidSourceResponses$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidSourceResponsesDto>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataPrebidSourceResponses.PATH, 'get');
  if (params) {
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.query('source', params.source, {});
    rb.query('succeeded', params.succeeded, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidSourceResponsesDto>;
    })
  );
}

getMongoDataPrebidSourceResponses.PATH = '/api/mongo-data/prebid-source-responses';
